/**
 * ISS-027 — node-extension section codes use the canonical module-prefixed
 * path format ("m1/1.2.7") that the backend rule
 * src/services/validation/nodeExtensionValidation.ts matches against
 * HC_ALLOWED_PARENTS. Users type the bare eCTD number ("1.2.7") because the
 * guidance told them to; it saved fine and only failed validation later.
 *
 * This normalizes ONLY the unambiguous case: a bare dotted-numeric code whose
 * first segment is the module number ("1.2.7" → "m1/1.2.7", "2.3" → "m2/2.3").
 * Anything already module-prefixed ("m1/1.2.7") or containing letters
 * ("3.2.P.1") is returned trimmed but otherwise untouched — the module cannot
 * be guessed there. It deliberately does NOT mirror the backend allow-list.
 */
export function normalizeNodeExtensionCode(code: string): string {
  const c = code.trim();
  const m = /^(\d+)(?:\.\d+)*$/.exec(c);
  return m ? `m${m[1]}/${c}` : c;
}
